<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import { required } from "vuelidate/lib/validators";
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/es';
import moment from 'moment';

import { categories } from "./data-calendar";

/**
 * Calendar component
 */
export default {
    components: { FullCalendar, Multiselect, DatePicker, moment },
    data() {
        return {
            title: "Calendar",
            items: [
                {
                text: "Calendar",
                active: true
                }
            ],
            eventTimeFormat: { // like '14:30:00'
                hour: '2-digit',
                minute: '2-digit'
            },
            calendarWeekends: true,
            calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                bootstrapPlugin,
                listPlugin
            ],
            themeSystem: "bootstrap",
            calendarEvents: [],
            showModal: false,
            eventModal: false,
            categories: categories,
            submitted: false,
            submit: false,
            newEventData: {},
            edit: {},
            deleteId: {},
            event: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            editevent: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            validations: {
                event: {
                    user_id: {required},
                    servicio: {required},
                    profesional: {required},
                    hora: {required}
                },
            },
            usersOptions:[],
            serviciosOptions:[],
            profesionalOptions:[],
            tipos:[],
            subtipos:[],
            copiado:false,
            sede:'',
            sedes:[],
            coordinador:'',
            allCoordinadores: [],
            coordinadores:[],
            calendarEventsFiltrados:[],
            isSmallScreen: window.innerWidth < 768
        };
    },
    validations: {
        event: {
            title: { required },
            category: { required }
        }
    },
    watch: {
        sede() {
            this.actualizarCoordinadores();
        }
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
        
    },
    methods: {
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        /**
         * Modal form submit
         */
        labelselect ({ name }) {
            return `${name}`
        },
        /**
         * Modal open for edit event
         */
        editEvent(info) { //mostrara info del evento
            console.log(info);
            this.edit = info.event;
            this.editevent = this.edit.extendedProps;
            this.eventModal = true;
        },
        closeModal() {
            this.eventModal = false;
        },
        get_data(){
            this.isLoading = true;
            axios.get('/api/get_proximos_eventos').then(res => {
                if (this.user.rol=='Admin') {
                    this.calendarEvents = res.data.eventos
                }else if(this.user.rol=='Supervisor'){
                    this.calendarEvents = res.data.eventos.filter((us) => us.sede_asociada==this.user.sede);
                }else if(this.user.rol=='Coordinador'){
                    this.calendarEvents = res.data.eventos.filter((us) => us.user_id == this.user.id);
                }
                this.calendarEventsFiltrados = [...this.calendarEvents];
                this.sedes = [...new Set(
                    this.calendarEvents
                        .map(item => item.sede_asociada)
                        .filter(sede => sede != 'null')
                    )];
                this.allCoordinadores = this.calendarEvents
                    .filter(item => item.coordinador_evento && item.coordinador_evento !== 'null' && item.coordinador_evento !== '')
                    .map(item => ({ nombre: item.coordinador_evento, sede: item.sede_asociada }));
                this.actualizarCoordinadores();
            }).catch(e => {
                this.isLoading = false;
            });
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        filtrarEventos() {
            let eventosFiltrados = this.calendarEvents;
            if (this.sede) {
                eventosFiltrados = eventosFiltrados.filter(evento => evento.sede_asociada === this.sede);
            }
            if (this.coordinador) {
                eventosFiltrados = eventosFiltrados.filter(evento => evento.coordinador_evento === this.coordinador);
            }
            this.calendarEventsFiltrados = eventosFiltrados;
        },
        actualizarCoordinadores() {
            let coordinadoresFiltrados = this.sede
                ? this.allCoordinadores.filter(c => c.sede === this.sede)
                : this.allCoordinadores;
            this.coordinadores = [...new Set(coordinadoresFiltrados.map(c => c.nombre))];
            if (!this.coordinadores.includes(this.coordinador)) {
                this.coordinador = '';
            }
        },
        handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        }
    },
    mounted() {
        this.get_data();
    },
    created(){
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<template>
    <div>
        <div class="row" v-if="user.rol=='Admin' || user.rol=='Supervisor'">
            <div class="col-md-12">
                <div class="card bg-soft-primary">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5" v-if="user.rol=='Admin'">
                                <b-form-group id="example text" :class="{ '': isSmallScreen, 'text-right': !isSmallScreen }" label-cols-sm="2" label-cols-lg="2" label="Sede :" label-for="text" >
                                    <multiselect
                                        v-model="sede"
                                        :options="sedes" 
                                        placeholder="Seleccionar sede" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div :class="user.rol=='Supervisor'?'offset-md-2 col-md-6':'col-md-5'">
                                <b-form-group id="example text" :class="{ '': isSmallScreen, 'text-right': !isSmallScreen }" label-cols-sm="2" label-cols-lg="3" label="Coordinador :" label-for="text" >
                                    <multiselect
                                        v-model="coordinador"
                                        :options="coordinadores" 
                                        placeholder="Seleccionar coordinador" 
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="filtrarEventos">Filtrar</b-button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="app-calendar">
                            <FullCalendar
                                ref="fullCalendar"
                                default-view="dayGridMonth"
                                locale= "es"
                                :firstDay='1'
                                :buttonText="{ today:'Hoy', month:'Mes', week:'Semana',day:'Dia',list:'Lista' }"
                                :header="{ left: 'prev,next today',center: 'title',right: 'dayGridMonth,timeGridWeek,timeGridDay' }"
                                :editable="false"
                                :droppable="false"
                                :plugins="calendarPlugins"
                                :events="calendarEventsFiltrados"
                                :weekends="calendarWeekends"
                                :theme-system="themeSystem"
                                :eventTimeFormat="eventTimeFormat"
                                @eventClick="editEvent"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Edit Modal -->
        <b-modal
        v-model="eventModal"
        title="Información Evento"
        title-class="text-black font-18"
        hide-footer
        body-class="p-4"
        >
            <div class="row">
                <div class="col-md-12">
                    <p class="font-size-16"><strong>Actividad:</strong> {{ editevent.nombre_difusion }}</p>
                    <p class="font-size-16"><strong>Código:</strong> {{ editevent.codigo }}</p>
                    <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ editevent.fecha_inicio }}</p><!--con hora -->
                    <p class="font-size-16"><strong>Fecha de término:</strong> {{ editevent.fecha_termino }}</p>
                    <p class="font-size-16 d-flex align-items-center" >
                        <strong>RBD:</strong> {{ editevent.rbd_colegio }} 
                    </p>
                    <p class="font-size-16"><strong>Colegio:</strong> {{ editevent.colegio }}</p>
                    <p class="font-size-16"><strong>Sede Asociada:</strong> {{ editevent.sede_asociada }}</p>
                    <p class="font-size-16"><strong>Propietario Colegio:</strong> {{ editevent.propietario_colegio }}</p>
                    <p class="font-size-16"><strong>Coordinador Evento:</strong> {{ editevent.coordinador_evento }}</p>
                </div>
            </div>
            <div class="text-right p-3">
                <b-button variant="light" @click="closeModal">Cerrar</b-button>
                <b-button variant="primary" @click="ver_evento(editevent.codigo)">Ir al Evento</b-button>
            </div>
        </b-modal>
    </div>
</template>
